var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24316 10.0996L4.24023 10.0635C4.2292 9.94865 4.1946 9.82877 4.13086 9.71484L4.1123 9.68066L4.08984 9.64844L4.07324 9.625L4.04883 9.5918L4.02246 9.56055L1.93945 7.20312C1.54622 6.75802 1.80669 6.08088 2.29688 5.97754L5.31445 5.34375L5.35449 5.33594L5.39355 5.32324L5.41992 5.31445L5.45996 5.30078L5.49902 5.2832C5.62854 5.22396 5.74203 5.13478 5.8291 5.02246L5.90723 4.90234L7.4082 2.13086L7.44922 2.05859C7.72278 1.63278 8.32804 1.64472 8.58105 2.11133L10.0918 4.90137L10.1133 4.94043L10.1387 4.97656L10.1553 5.00098L10.1758 5.0293L10.1992 5.05664C10.3247 5.2028 10.4951 5.30374 10.6836 5.34375H10.6846L13.7021 5.97754C14.1747 6.07676 14.4378 6.70997 14.0977 7.15723L14.0508 7.21484L11.9785 9.55957C11.8097 9.75029 11.7345 10.0009 11.7607 10.2441L11.7617 10.2461L12.1123 13.4043V13.4053L12.1182 13.4863H12.1191C12.1451 14.0714 11.5889 14.3828 11.1748 14.1855L8.37598 12.8535L8.24219 12.8027C8.10424 12.7628 7.95469 12.7565 7.80664 12.79L7.7627 12.7998L7.7207 12.8145L7.69434 12.8242L7.6582 12.8369L7.62305 12.8535L4.82422 14.1855C4.39932 14.3879 3.81579 14.0503 3.88477 13.4287L4.23828 10.2461L4.24316 10.2051V10.0996Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIcon);
export default __webpack_public_path__ + "static/media/AssessmentIcon.e8ebb9fd4c50abadfec08df29880f7aa.svg";
export { ForwardRef as ReactComponent };